import { AuthMethodLink } from './_auth_method_link.component';
import { AuthMethods } from './_auth_methods.component';
import { AuthSignInSheet } from './_auth_sign_in_sheet.component';

export const Auth = {
	MethodLink: AuthMethodLink,
	Methods: AuthMethods,
	SignInSheet: AuthSignInSheet,
};
